<template>
	<div>
		<router-link :to="{ name: 'offers', query: { company_id: payload.id, company_name: payload.name } }">
			<a class="button is-info is-outlined custom_operation_btn">Offers</a>
		</router-link>
	</div>
</template>
<script>
	export default {
		name: 'company-offers-router-link',
		props: ['payload']
	}
</script>